export const navItems = [
  { id: "board", label: "真假看板" },
  { id: "collections", label: "合集索引" },
  { id: "reversals", label: "反转事件" },
  { id: "statements", label: "声明汇总" },
  { id: "timeline", label: "回应时间线" },
  { id: "discussions", label: "社区讨论" },
];

export const quickTags = [
  "辟谣澄清",
  "剧情反转",
  "官方声明",
  "时间线补齐",
  "证据存疑",
  "后续更新",
];

export const tickerItems = [
  "【反转】某工作室称早前录音系剪辑，完整版本已交由平台核验",
  "【辟谣】网传截图被证实为旧图重新拼接，原出处可追溯至两年前",
  "【待核实】当事人直播回应三处关键时间点，与通报存在二十分钟差口",
  "【声明】品牌方发布书面说明，强调未参与任何私下调解",
  "【更新】平台方追加一条补充公告，公开后台操作日志片段",
  "【反转】匿名爆料帖作者注销账号，评论区要求给出原始素材",
];

export const statusBoard = [
  {
    key: "debunked",
    label: "已辟谣",
    count: "1,284",
    delta: "+36 今日",
    desc: "经交叉比对后确认不实，原始出处已标注",
    icon: "ri-shield-check-line",
    tone: "accent",
  },
  {
    key: "reversed",
    label: "出现反转",
    count: "326",
    delta: "+12 今日",
    desc: "说法前后产生变化，两版内容并排陈列",
    icon: "ri-loop-left-line",
    tone: "primary",
  },
  {
    key: "pending",
    label: "待核实",
    count: "517",
    delta: "+19 今日",
    desc: "证据链尚不完整，仅记录各方表述不作结论",
    icon: "ri-question-line",
    tone: "secondary",
  },
  {
    key: "ongoing",
    label: "持续更新",
    count: "89",
    delta: "进行中",
    desc: "各方回应仍在增加，页面会自动补上新一轮",
    icon: "ri-refresh-line",
    tone: "foreground",
  },
];

export const heroStats = [
  { value: "2,216", label: "在跟踪事件" },
  { value: "7,905", label: "条各方回应" },
  { value: "48h", label: "平均补齐时间线用时" },
];

export const timelineEvents = [
  {
    time: "09-08 21:40",
    title: "首条爆料帖发布",
    detail: "匿名账号放出片段音频与两张聊天截图，配文声称掌握完整内幕。",
    type: "爆料",
    tone: "primary",
  },
  {
    time: "09-08 23:15",
    title: "涉事工作室第一轮回应",
    detail: "发布简短书面声明，称录音经过剪辑，保留法律追究权利。",
    type: "声明",
    tone: "secondary",
  },
  {
    time: "09-09 09:02",
    title: "平台方介入核查",
    detail: "平台安全团队表示已调取后台操作日志，将在核实后公布结论。",
    type: "平台",
    tone: "accent",
  },
  {
    time: "09-09 14:26",
    title: "爆料者补充原始素材",
    detail: "放出第二段视频，但画面存在明显拼接痕迹，评论出现转向。",
    type: "反转",
    tone: "primary",
  },
  {
    time: "09-09 18:50",
    title: "多位当事人同步发声",
    detail: "三名被提及者先后发文，口径一致否认核心指控并附定位记录。",
    type: "声明",
    tone: "secondary",
  },
  {
    time: "09-10 08:30",
    title: "辟谣结论进入待公布",
    detail: "本站比对七处时间戳后标注为待核实，等待平台方最终通报。",
    type: "辟谣",
    tone: "accent",
  },
  {
    time: "09-10 12:05",
    title: "新一轮回应仍在增加",
    detail: "品牌合作方补充说明合作已中止，评论区要求公开合同要点。",
    type: "更新",
    tone: "foreground",
  },
];

export const classroomTips = [
  {
    icon: "ri-time-line",
    title: "先看时间戳，再看结论",
    desc: "同一件事的截图往往来自不同日期，把时间线排好，很多所谓矛盾会自己消失。",
  },
  {
    icon: "ri-stack-line",
    title: "把两版说法并排放",
    desc: "本站会把前后两版内容并列陈列，词语的细微改动常常就是反转的起点。",
  },
  {
    icon: "ri-links-line",
    title: "找到原始出处再转发",
    desc: "截图之外先问一句原始链接在哪，找不到源头的说法一律先标注待核实。",
  },
  {
    icon: "ri-emotion-line",
    title: "情绪最满的时候先慢一拍",
    desc: "越是让你立刻想站队的表述，越值得等一等各方声明和后续通报。",
  },
];

export const hotTopics = [
  { label: "录音剪辑之争", count: 412 },
  { label: "工作室声明口径", count: 288 },
  { label: "平台操作日志", count: 196 },
  { label: "旧图重新拼接", count: 154 },
  { label: "合作方紧急解约", count: 121 },
];

export const contributors = [
  { name: "核验小分队", badge: "时间线贡献", posts: 318, initial: "核" },
  { name: "苔原观测员", badge: "原始出处", posts: 246, initial: "苔" },
  { name: "不急着站队", badge: "对照整理", posts: 205, initial: "不" },
  { name: "慢一拍吃瓜", badge: "声明归档", posts: 177, initial: "慢" },
];